import React from 'react';
export function University() {
  return <section className="py-8 bg-navy" data-id="element-302">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">
        <div className="text-center mb-10" data-id="element-304">
          <span className="inline-block bg-yellow/20 text-yellow font-bold text-xs px-3 py-1 rounded-full uppercase tracking-wider mb-4" data-id="element-305">
            Respaldado por Ciencia Mexicana
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-4" data-id="element-306">
            Desarrollado por especialistas en neurociencia clínica
          </h2>
          <p className="text-offwhite/70 text-lg max-w-3xl mx-auto" data-id="element-307">
            El Protocolo 120 Segundos (de Neuro-Control Mental) fue creado en
            colaboración con el Departamento de Psicobiología de la Universidad
            Nacional Autónoma de México (UNAM)
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden mb-4" data-id="element-308">
          <img src="https://cdn.magicpatterns.com/uploads/aw2opWzLk43qukggEUkXrT/heylloyd-image-1773409910983.png" alt="Equipo de investigación en neurociencia" className="w-full h-64 md:h-80 object-cover" data-id="element-309" />
        </div>
      </div>
    </section>;
}